import React from "react";
import useHttpRequests from "../../hooks/useHttpRequests";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../reducers/selectedValues";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export const ConfirmationDialog = (props) => {
  const { open, setDialogOpen, confirmationDialogAttributes } = props;
  const confirmationDispatch = useDispatch();

  const { sendRequest: updateAction } = useHttpRequests();

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleConfirmAction = (_key, status) => {
    const getUpdateResponse = (resObj) => {
      if (
        !resObj ||
        !resObj["isSuccess"] ||
        (resObj["validationErrors"] !== undefined &&
          resObj["validationErrors"]?.length > 0)
      ) {
        confirmationDispatch(
          setMessageHandler({
            type: "error",
            message:
              confirmationDialogAttributes?.messageTitle +
              ": " +
              resObj["message"] +
              (resObj["validationErrors"]?.length > 0
                ? "\n" + resObj["validationErrors"]?.join("\n")
                : ""),
          })
        );
      } else {
        confirmationDispatch(
          setMessageHandler({
            type: "success",
            message:
              confirmationDialogAttributes?.messageTitle +
              " status updated successfully!",
          })
        );
        setTimeout(() => {
          confirmationDispatch(
            setMessageHandler({ type: null, message: null })
          );
        }, 2000);
      }
      handleCloseDialog();
    };

    if (_key === "missingDates") {
      handleCloseDialog();
      return props.deleteMissingDatesData();
    } else {
      updateAction(
        {
          url: confirmationDialogAttributes["url"] + _key,
          method: "PATCH",
          body: {
            [confirmationDialogAttributes["keyField"]]: _key,
            active: status,
          },
        },
        getUpdateResponse
      );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "calc(20vh/2)",
      }}
    >
      <DialogTitle>
        {confirmationDialogAttributes.title || "Confirm Action"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {confirmationDialogAttributes.message || "Are you sure?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          {confirmationDialogAttributes.cancelText || "Cancel"}
        </Button>
        <Button
          onClick={() =>
            handleConfirmAction(
              confirmationDialogAttributes["key"],
              confirmationDialogAttributes["status"]
            )
          }
          color="primary"
        >
          {confirmationDialogAttributes.confirmText || "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
